<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">API Usage Dashboard</span><br/>
      <span style="font-style: italic; font-size: 18px">track API requests by endpoint and tenant</span>
    </div>

    <div style="position: relative; font-size: 20px; font-weight: bold;" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_week(-1)">&lt;</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="start_date" :config="date_options" :placeholder="start_date"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="end_date" :config="date_options" :placeholder="end_date"/>
      &nbsp;<a href="#" class="arrows" v-on:click.prevent="shift_week(1)">&gt;</a>
      &nbsp;&nbsp;|&nbsp;&nbsp;Tenant&nbsp;<b-form-select v-model="selected_tenant" :options="computed_tenant_options" style="width: 250px;" @change="load_data()"></b-form-select>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
    </div>
    <br/>

    <div v-if="loading" class="text-center" style="margin-top: 40px;">
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <!-- ===================== INTERNAL API USAGE ===================== -->
    <div v-if="!loading && usage_data">
      <div style="font-size: 22px; font-weight: bold; color: white; background-color: #2c3e50; padding: 8px 12px; margin-bottom: 0; cursor: pointer; display: flex; align-items: center; justify-content: space-between;"
           v-on:click="show_internal_section = !show_internal_section">
        <span>Internal API Usage</span>
        <span style="font-size: 14px;">{{ show_internal_section ? '▲' : '▼' }}</span>
      </div>

      <div v-if="show_internal_section" style="padding-top: 15px;">
        <div style="margin-bottom: 10px;">
          <span style="font-size: 20px; font-weight: bold;">Total Requests: {{ usage_data.total_requests.toLocaleString() }}</span>
        </div>

        <div class="d-flex align-items-center justify-content-center" style="margin-bottom: 10px;">
          <span style="font-size: 16px; font-weight: bold; margin-right: 10px;">Filter Chart:</span>
          <b-form-select v-model="selected_chart_path" :options="computed_chart_path_options" style="width: 400px;" @change="update_chart"></b-form-select>
        </div>

        <dashboard-chart
            v-if="requests_by_date_chart"
            :loading="loading"
            :chart_data="requests_by_date_chart"
            chart_type="LineChart"
            :graph_title="chart_title"
            date_format="MM/dd"
            graph_height="300"
        />

        <div v-if="!selected_tenant && usage_data.by_tenant && usage_data.by_tenant.length > 0" style="margin-top: 30px;">
          <div style="font-size: 20px; font-weight: bold; color: white; background-color: steelblue; padding: 5px 10px; cursor: pointer;"
               v-on:click="show_tenant_table = !show_tenant_table">
            Usage By Tenant ({{ usage_data.by_tenant.length }})
          </div>
          <b-table
              v-if="show_tenant_table"
              :items="usage_data.by_tenant"
              :fields="tenant_fields"
              striped hover small bordered
              sort-by="count"
              :sort-desc="true"
              style="margin-top: 10px;"
          >
            <template #cell(count)="data">
              {{ data.value.toLocaleString() }}
            </template>
          </b-table>
        </div>

        <div style="margin-top: 30px;">
          <div style="font-size: 20px; font-weight: bold; color: white; background-color: steelblue; padding: 5px 10px; cursor: pointer;"
               v-on:click="show_path_table = !show_path_table">
            Usage By API Endpoint ({{ usage_data.by_path.length }})
          </div>
          <b-table
              v-if="show_path_table"
              :items="usage_data.by_path"
              :fields="path_fields"
              striped hover small bordered
              sort-by="count"
              :sort-desc="true"
              :per-page="per_page"
              :current-page="current_page"
              style="margin-top: 10px;"
          >
            <template #cell(count)="data">
              {{ data.value.toLocaleString() }}
            </template>
          </b-table>
          <b-pagination
              v-if="show_path_table && usage_data.by_path.length > per_page"
              v-model="current_page"
              :total-rows="usage_data.by_path.length"
              :per-page="per_page"
              align="center"
              style="margin-top: 10px;"
          ></b-pagination>
        </div>

        <div v-if="usage_data.by_date && usage_data.by_date.length > 0" style="margin-top: 30px;">
          <div style="font-size: 20px; font-weight: bold; color: white; background-color: steelblue; padding: 5px 10px; cursor: pointer;"
               v-on:click="show_date_table = !show_date_table">
            Usage By Date ({{ usage_data.by_date.length }})
          </div>
          <b-table
              v-if="show_date_table"
              :items="usage_data.by_date"
              :fields="date_fields"
              striped hover small bordered
              sort-by="date"
              :sort-desc="true"
              style="margin-top: 10px;"
          >
            <template #cell(count)="data">
              {{ data.value.toLocaleString() }}
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- ===================== TBN API USAGE ===================== -->
    <div v-if="!loading && tbn_usage_data" style="margin-top: 50px;">
      <div style="font-size: 22px; font-weight: bold; color: white; background-color: #8e44ad; padding: 8px 12px; margin-bottom: 0; cursor: pointer; display: flex; align-items: center; justify-content: space-between;"
           v-on:click="show_tbn_section = !show_tbn_section">
        <span>TBN API Usage</span>
        <span style="font-size: 14px;">{{ show_tbn_section ? '▲' : '▼' }}</span>
      </div>

      <div v-if="show_tbn_section" style="padding-top: 15px;">
      <div class="d-flex align-items-center justify-content-center" style="margin-bottom: 10px;">
        <span style="font-size: 16px; font-weight: bold; margin-right: 10px;">View:</span>
        <b-form-select v-model="tbn_view_mode" :options="tbn_view_mode_options" style="width: 250px;" @change="on_tbn_view_change"></b-form-select>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="font-size: 20px; font-weight: bold;">{{ tbn_view_label }}: {{ tbn_view_total.toLocaleString() }}</span>
      </div>

      <div class="d-flex align-items-center justify-content-center" style="margin-bottom: 10px;">
        <span style="font-size: 16px; font-weight: bold; margin-right: 10px;">Filter Chart:</span>
        <b-form-select v-model="tbn_selected_chart_path" :options="tbn_computed_chart_path_options" style="width: 400px;" @change="update_tbn_chart"></b-form-select>
      </div>

      <dashboard-chart
          v-if="tbn_requests_by_date_chart"
          :loading="loading"
          :chart_data="tbn_requests_by_date_chart"
          chart_type="LineChart"
          :graph_title="tbn_chart_title"
          date_format="MM/dd"
          graph_height="300"
      />

      <div v-if="!selected_tenant && tbn_usage_data.by_tenant && tbn_usage_data.by_tenant.length > 0 && tbn_view_mode === 'all'" style="margin-top: 30px;">
        <div style="font-size: 20px; font-weight: bold; color: white; background-color: #9b59b6; padding: 5px 10px; cursor: pointer;"
             v-on:click="tbn_show_tenant_table = !tbn_show_tenant_table">
          Usage By Tenant ({{ tbn_usage_data.by_tenant.length }})
        </div>
        <b-table
            v-if="tbn_show_tenant_table"
            :items="tbn_usage_data.by_tenant"
            :fields="tenant_fields"
            striped hover small bordered
            sort-by="count"
            :sort-desc="true"
            style="margin-top: 10px;"
        >
          <template #cell(count)="data">
            {{ data.value.toLocaleString() }}
          </template>
        </b-table>
      </div>

      <div v-if="tbn_view_paths.length > 0" style="margin-top: 30px;">
        <div style="font-size: 20px; font-weight: bold; color: white; background-color: #9b59b6; padding: 5px 10px; cursor: pointer;"
             v-on:click="tbn_show_path_table = !tbn_show_path_table">
          Usage By TBN Endpoint ({{ tbn_view_paths.length }})
        </div>
        <b-table
            v-if="tbn_show_path_table"
            :items="tbn_view_paths"
            :fields="path_fields"
            striped hover small bordered
            sort-by="count"
            :sort-desc="true"
            :per-page="per_page"
            :current-page="tbn_current_page"
            style="margin-top: 10px;"
        >
          <template #cell(count)="data">
            {{ data.value.toLocaleString() }}
          </template>
        </b-table>
        <b-pagination
            v-if="tbn_show_path_table && tbn_view_paths.length > per_page"
            v-model="tbn_current_page"
            :total-rows="tbn_view_paths.length"
            :per-page="per_page"
            align="center"
            style="margin-top: 10px;"
        ></b-pagination>
      </div>

      <div v-if="tbn_view_dates.length > 0" style="margin-top: 30px;">
        <div style="font-size: 20px; font-weight: bold; color: white; background-color: #9b59b6; padding: 5px 10px; cursor: pointer;"
             v-on:click="tbn_show_date_table = !tbn_show_date_table">
          Usage By Date ({{ tbn_view_dates.length }})
        </div>
        <b-table
            v-if="tbn_show_date_table"
            :items="tbn_view_dates"
            :fields="date_fields"
            striped hover small bordered
            sort-by="date"
            :sort-desc="true"
            style="margin-top: 10px;"
        >
          <template #cell(count)="data">
            {{ data.value.toLocaleString() }}
          </template>
        </b-table>
      </div>
      </div>
    </div>

    <div v-if="!loading && !usage_data && !tbn_usage_data && has_loaded" class="text-center" style="margin-top: 40px;">
      <h4>No usage data found for the selected date range.</h4>
    </div>
  </div>
</template>

<script>
import { get_api_usage } from '../networking/apis'
import { get_tbn_api_usage } from '../networking/tbn_apis'
import { mapState } from 'vuex'
import { justDate } from '../helpers/dates'
import moment from 'moment'
import DashboardChart from './DashboardChart'

export default {
  name: 'api_usage_dashboard',
  components: {
    DashboardChart,
  },
  data() {
    return {
      loading: false,
      has_loaded: false,
      usage_data: null,
      requests_by_date_chart: null,
      selected_chart_path: '',
      tbn_usage_data: null,
      tbn_requests_by_date_chart: null,
      tbn_selected_chart_path: '',
      selected_tenant: '',
      start_date: justDate(moment().subtract(7, 'days')),
      end_date: justDate(moment().add(1, 'days')),
      show_internal_section: true,
      show_tenant_table: true,
      show_path_table: true,
      show_date_table: false,
      tbn_view_mode: 'all',
      tbn_view_mode_options: [
        { value: 'all', text: 'All Requests' },
        { value: 'api_calls', text: 'API Calls Only' },
        { value: 'cache_hits', text: 'Cache Hits Only' },
      ],
      show_tbn_section: true,
      tbn_show_tenant_table: true,
      tbn_show_path_table: true,
      tbn_show_date_table: false,
      per_page: 25,
      current_page: 1,
      tbn_current_page: 1,
      date_options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(1, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
      tenant_fields: [
        { key: 'tenant_id', label: 'Tenant', sortable: true },
        { key: 'count', label: 'Requests', sortable: true },
      ],
      path_fields: [
        { key: 'path', label: 'API Endpoint', sortable: true },
        { key: 'count', label: 'Requests', sortable: true },
      ],
      date_fields: [
        { key: 'date', label: 'Date', sortable: true },
        { key: 'count', label: 'Requests', sortable: true },
      ],
    }
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    computed_tenant_options() {
      const options = [{ value: '', text: 'All Tenants' }]
      if (this.user && this.user.tenant_options && this.user.tenant_options.length > 0) {
        this.user.tenant_options.forEach(opt => {
          options.push({ value: opt.value, text: opt.text })
        })
      }
      return options
    },
    computed_chart_path_options() {
      const options = [{ value: '', text: 'All Endpoints' }]
      if (this.usage_data && this.usage_data.by_path) {
        this.usage_data.by_path.forEach(item => {
          options.push({ value: item.path, text: item.path + ' (' + item.count.toLocaleString() + ')' })
        })
      }
      return options
    },
    chart_title() {
      if (this.selected_chart_path) {
        return 'Requests By Date — ' + this.selected_chart_path
      }
      return 'Requests By Date'
    },
    tbn_active_data() {
      if (!this.tbn_usage_data) return null
      if (this.tbn_view_mode === 'api_calls' && this.tbn_usage_data.api_calls) return this.tbn_usage_data.api_calls
      if (this.tbn_view_mode === 'cache_hits' && this.tbn_usage_data.cache_hits) return this.tbn_usage_data.cache_hits
      return { by_path: this.tbn_usage_data.by_path, by_date: this.tbn_usage_data.by_date, by_path_date: this.tbn_usage_data.by_path_date }
    },
    tbn_view_total() {
      if (!this.tbn_usage_data) return 0
      if (this.tbn_view_mode === 'api_calls') return this.tbn_usage_data.total_api_calls || 0
      if (this.tbn_view_mode === 'cache_hits') return this.tbn_usage_data.total_cache_hits || 0
      return this.tbn_usage_data.total_requests || 0
    },
    tbn_view_label() {
      if (this.tbn_view_mode === 'api_calls') return 'Total API Calls'
      if (this.tbn_view_mode === 'cache_hits') return 'Total Cache Hits'
      return 'Total Requests'
    },
    tbn_view_paths() {
      if (!this.tbn_active_data) return []
      return this.tbn_active_data.by_path || []
    },
    tbn_view_dates() {
      if (!this.tbn_active_data) return []
      return this.tbn_active_data.by_date || []
    },
    tbn_computed_chart_path_options() {
      const options = [{ value: '', text: 'All Endpoints' }]
      if (this.tbn_view_paths) {
        this.tbn_view_paths.forEach(item => {
          options.push({ value: item.path, text: item.path + ' (' + item.count.toLocaleString() + ')' })
        })
      }
      return options
    },
    tbn_chart_title() {
      const suffix = this.tbn_view_mode === 'api_calls' ? ' (API Calls)' : this.tbn_view_mode === 'cache_hits' ? ' (Cache Hits)' : ''
      if (this.tbn_selected_chart_path) {
        return 'TBN Requests By Date — ' + this.tbn_selected_chart_path + suffix
      }
      return 'TBN Requests By Date' + suffix
    },
  },
  async created() {
    await this.load_data()
  },
  methods: {
    shift_week(weeks) {
      const from = moment(this.start_date, 'MM-DD-YYYY').add(weeks, 'weeks')
      const to = moment(this.end_date, 'MM-DD-YYYY').add(weeks, 'weeks')
      this.start_date = justDate(from)
      this.end_date = justDate(to)
      this.load_data()
    },
    _build_chart_data(date_data) {
      if (date_data && date_data.length > 0) {
        return [
          ['Date', 'Requests'],
          ...date_data.map(({ date, count }) => [
            moment(String(date)).format('MM/DD'),
            Number(count || 0),
          ])
        ]
      }
      return null
    },
    update_chart() {
      if (!this.usage_data) return
      let date_data = null
      if (this.selected_chart_path && this.usage_data.by_path_date && this.usage_data.by_path_date[this.selected_chart_path]) {
        date_data = this.usage_data.by_path_date[this.selected_chart_path]
      } else {
        date_data = this.usage_data.by_date
      }
      this.requests_by_date_chart = this._build_chart_data(date_data)
    },
    update_tbn_chart() {
      if (!this.tbn_active_data) return
      let date_data = null
      const pd = this.tbn_active_data.by_path_date
      if (this.tbn_selected_chart_path && pd && pd[this.tbn_selected_chart_path]) {
        date_data = pd[this.tbn_selected_chart_path]
      } else {
        date_data = this.tbn_active_data.by_date
      }
      this.tbn_requests_by_date_chart = this._build_chart_data(date_data)
    },
    on_tbn_view_change() {
      this.tbn_selected_chart_path = ''
      this.tbn_current_page = 1
      this.update_tbn_chart()
    },
    async load_data() {
      this.loading = true
      this.usage_data = null
      this.tbn_usage_data = null
      this.requests_by_date_chart = null
      this.tbn_requests_by_date_chart = null
      this.selected_chart_path = ''
      this.tbn_selected_chart_path = ''
      this.tbn_view_mode = 'all'
      this.current_page = 1
      this.tbn_current_page = 1

      const sd = moment(this.start_date, 'MM-DD-YYYY').format('YYYY-MM-DD')
      const ed = moment(this.end_date, 'MM-DD-YYYY').format('YYYY-MM-DD')
      const tenant = this.selected_tenant === '' ? '' : this.selected_tenant

      const [internal_result, tbn_result] = await Promise.allSettled([
        get_api_usage(tenant, sd, ed),
        get_tbn_api_usage(tenant, sd, ed),
      ])

      if (internal_result.status === 'fulfilled') {
        try {
          this.usage_data = internal_result.value.value.data
          this.update_chart()
        } catch (e) {
          this.usage_data = null
        }
      }

      if (tbn_result.status === 'fulfilled') {
        try {
          this.tbn_usage_data = tbn_result.value.value.data
          this.update_tbn_chart()
        } catch (e) {
          this.tbn_usage_data = null
        }
      }

      this.loading = false
      this.has_loaded = true
    },
  }
}
</script>
